var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"linkparts"}},[_c('f7-navbar',{attrs:{"title":"Part Links","back-link":"Back"}}),_vm._v(" "),_c('f7-list',[_c('f7-list-item',[_c('a',{staticClass:"link external",attrs:{"href":"https://vision.truckserviceco.com/vision/search/","target":"_blank"}},[_vm._v("Vision search")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }